interface IProps {
	msg: string | undefined;
}

export const FormErrorMsg = ({ msg }: IProps) => {
	return <p className='m-0 p-0 text-danger'>{'*' + msg}</p>;
};
